import affiliate from './de/affiliate'
import bankTransfer from './de/bankTransfer'
import cart from './de/cart'
import cartAndWarehouse from './de/cartAndWarehouse'
import common from './de/common'
import consult from './de/consult'
import debt from './de/debt'
import distribution from './de/distribution'
import estimation from './de/estimation'
import form from './de/form'
import home from './de/home'
import kol from './de/kol'
import order from './de/order'
import orderDetail from './de/orderDetail'
import packages from './de/package'
import pay from './de/pay'
import pecenter from './de/pecenter'
import points from './de/points'
import previewPackage from './de/previewPackage.json'
import previewPackageOptimize from './de/previewPackageOptimize'
import product from './de/product'
import returnChange from './de/returnChange'
import search from './de/search'
import shareCoupon from './de/shareCoupon'
import sharePackage from './de/sharePackage'
import shoppingGuide from './de/shoppingGuide'
import site from './de/site'
import status from './de/status'
import storage from './de/storage'
import tag from './de/tag'
import tips from './de/tips'
import transport from './de/transport'
import uniOrder from './de/uniOrder'
import warnTips from './de/warnTips'
export default {
  form,
  home,
  search,
  cart,
  product,
  order,
  pecenter,
  pay,
  common,
  estimation,
  packages,
  orderDetail,
  warnTips,
  status,
  tips,
  storage,
  uniOrder,
  bankTransfer,
  distribution,
  site,
  consult,
  transport,
  previewPackage,
  sharePackage,
  debt,
  previewPackageOptimize,
  points,
  shareCoupon,
  shoppingGuide,
  tag,
  cartAndWarehouse,
  affiliate,
  returnChange,
  kol,
}
